// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview {
  display: flex;
  margin-top: 1rem;
  position: relative;
}
.preview .thumbnail {
  width: 50px;
  margin-right: 1rem;
  flex: 0 0 auto;
}
.preview .thumbnail img {
  max-width: 100%;
}
.preview .info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: calc(100% - 4rem);
  justify-content: space-between;
}
.preview .info p {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 300;
  line-height: 1.4rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.preview .remove {
  position: absolute;
  right: 0;
  top: 0.3rem;
  opacity: 0.7;
  transition: 0.2s;
  cursor: pointer;
}
.preview .remove:hover {
  opacity: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
